(function () {
  function syncMobileCartBadge() {
    const source = document.getElementById('cart-icon-bubble');
    const target = document.querySelector('[data-cart-icon-sync]');
    if (!source || !target) return;

    const countNode = source.querySelector('.cart-count-bubble [aria-hidden="true"]');
    const count = countNode?.textContent?.trim();
    let badge = target.querySelector('.pairfit-mobile-nav__badge');

    if (count) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'pairfit-mobile-nav__badge';
        badge.setAttribute('aria-hidden', 'true');
        target.appendChild(badge);
      }
      badge.textContent = count;
      target.closest('.pairfit-mobile-nav__link')?.classList.add('pairfit-mobile-nav__link--has-badge');
    } else {
      badge?.remove();
      target.closest('.pairfit-mobile-nav__link')?.classList.remove('pairfit-mobile-nav__link--has-badge');
    }
  }

  function initMobileNav() {
    syncMobileCartBadge();

    const headerCart = document.getElementById('cart-icon-bubble');
    if (headerCart && typeof MutationObserver !== 'undefined') {
      new MutationObserver(syncMobileCartBadge).observe(headerCart, {
        childList: true,
        subtree: true,
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, syncMobileCartBadge);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileNav);
  } else {
    initMobileNav();
  }
})();
